import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from '@/router/routes'
// import NProgress from 'nprogress'

Vue.use(VueRouter)

const router = new VueRouter({
  strict: process.env.NODE_ENV !== 'production',
  // mode: 'history',
  routes,
  base: process.env.BASE_URL
})

router.beforeEach((to, from, next) => {
  // If this isn't an initial page load.
  if (to.path) {
    // Inicia o progressbar a cada rota
    // NProgress.start()
    // NProgress.set(0.1)
  }
  next()
})

router.afterEach(() => {
  // Para o progressbar
  // setTimeout(() => NProgress.done(), 500)
})

// router.beforeEach(guard)

export default router
